import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { IStyled } from '../../../styles/types';
import { SvgIcon } from '../../../components/Icon';

interface IProps extends IStyled {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  autoFocus?: boolean;
}

const Container = styled.div`
  position: relative;
  max-width: 100%;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 10%);
  color: rgba(255, 255, 255, 80%);
`;
const StyledSearchIcon = styled(SvgIcon)`
  position: absolute;
  top: 5px;
  left: 5px;
`;
const StyledInput = styled.input`
  position: relative;
  width: 100%;
  height: 32px;
  border-radius: 4px;
  padding-right: 30px;
  padding-left: 36px;
  border: 0;
  font: inherit;
  font-size: 12px;
  line-height: normal;
  color: inherit;
  background: unset;
  outline: none;
  &::placeholder {
    font: inherit;
    font-size: 12px;
    font-weight: 500;
    line-height: normal;
    opacity: 30%;
    color: inherit;
  }
`;
const StyledResetIcon = styled(SvgIcon)`
  position: absolute;
  top: 9px;
  right: 8px;
  &:hover {
    cursor: pointer;
  }
`;

const SearchBar = forwardRef<HTMLInputElement, IProps>(
  ({ value, placeholder, onChange, autoFocus, className }, ref) => {
    const [focused, setFocused] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    };
    const handleReset = () => {
      onChange('');
    };

    const hasValue = value.length > 0 || focused;

    return (
      <Container
        className={className}
        style={
          hasValue
            ? {
                color: '#fff',
              }
            : undefined
        }
      >
        <StyledInput
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          ref={ref}
          autoFocus={autoFocus}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        <StyledSearchIcon
          name="magnifying-glass"
          width={24}
          height={24}
          customFill="currentColor"
        />
        {value.length > 0 && (
          <StyledResetIcon
            name="icon-x"
            width={14}
            height={14}
            customFill="currentColor"
            onClick={handleReset}
            isHoverable={true}
          />
        )}
      </Container>
    );
  },
);

export default SearchBar;
